// Shared ISO-3166 country list for profile pickers + admin broadcast filter. Kept in
// one place so we only have to add a new country once. Use the literal flag emoji in
// labels because some platforms don't render Kosovo's `XK` via the regional-indicator
// trick (XK is unofficial in Unicode).

export const COUNTRY_OPTIONS = [
  { code: "", label: "— Not set —" },
  { code: "FR", label: "🇫🇷 France" },
  { code: "DE", label: "🇩🇪 Germany" },
  { code: "ES", label: "🇪🇸 Spain" },
  { code: "IT", label: "🇮🇹 Italy" },
  { code: "NL", label: "🇳🇱 Netherlands" },
  { code: "PT", label: "🇵🇹 Portugal" },
  { code: "AT", label: "🇦🇹 Austria" },
  { code: "CZ", label: "🇨🇿 Czech Republic" },
  { code: "GR", label: "🇬🇷 Greece" },
  { code: "IE", label: "🇮🇪 Ireland" },
  { code: "BE", label: "🇧🇪 Belgium" },
  { code: "DK", label: "🇩🇰 Denmark" },
  { code: "AL", label: "🇦🇱 Albania" },
  // Western Balkans
  { code: "XK", label: "🇽🇰 Kosovo" },
  { code: "ME", label: "🇲🇪 Montenegro" },
  { code: "MK", label: "🇲🇰 North Macedonia" },
  // Rest of Europe
  { code: "GB", label: "🇬🇧 United Kingdom" },
  { code: "CH", label: "🇨🇭 Switzerland" },
  { code: "PL", label: "🇵🇱 Poland" },
  { code: "SE", label: "🇸🇪 Sweden" },
  { code: "NO", label: "🇳🇴 Norway" },
];
